import TopNavbar from '@/Components/TopNavbar.jsx';

export default function Global({ children }) {
    return (
        <div>
            <TopNavbar />
            <div className="container mx-auto">{children}</div>
        </div>
    );
}
